var link_viewer_default = {
  "fontElementMap": "vRR0E",
  "link": "jAXr1",
  "linkInEditor": "vkAu7",
  "linkInViewer": "YSKc2",
  "toolbarUrlContainer": "LqAmJ",
  "toolbarUrl": "ykSBy",
  "toolbarUrlAnchor": "jSByJ"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
